import { StrictMode } from "react";

import "@obs/base/fonts.css";
import "@obs/base/reset.css";
import { createRoot } from "react-dom/client";

import { TemporalProvider } from "./components/TemporalProvider";
import { LocaleProvider } from "./LocaleProvider";
import { QueryClientProvider } from "./QueryClientProvider";

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<TemporalProvider>
			<QueryClientProvider>
				<LocaleProvider />
			</QueryClientProvider>
		</TemporalProvider>
	</StrictMode>,
);
